export var HistoryActionTypes = /*#__PURE__*/function (HistoryActionTypes) {
  HistoryActionTypes["UPDATE"] = "UPDATE";
  return HistoryActionTypes;
}({});